import instance from '../../axios/utils.ts/instance';

export const putRecentlyLearning = async (
  learningId: string,
  lessonId: string
) => {
  try {
    const response = await instance.put(
      `/v1/learning/${learningId}/recently-learning-content/${lessonId}`
    );
    return response.data.data;
  } catch (error) {
    console.error(error);
  }
};
interface LearningLessonContentType  {
  id: string;
  displayName: string | null;
  division: string; //"materials" | 
  name: string;
  type: 'Vimeo' | 'HTML' | string;
  vimeo_key?: string;
  running_time: string;
  created_at: Date;
  updated_at: Date;
  path: string;
  exe_file?: {
    id?: string;
    type?: string;
    size?: number;
    resource_path?: string;
    origin_file_name?: string;
    access_url?: string;
    need_permission?: boolean;
    is_draft?: boolean;
    created_at?: Date;
    updated_at?: Date;
  };
};
/**
 * 교사대학 학습 콘텐츠 뷰 가져오기
 * @param classId
 * @param contentId
 * @returns
 */
export const getContentView = async (classId: string, contentId: string): Promise<LearningLessonContentType> => {
  try {
    const response = await instance.get<{
      content: LearningLessonContentType;
    }>(`/v1/contents-app/view/${classId}/${contentId}`);
    return response.data.content;
  } catch (error) {}
};
